import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import OutsideClickHandler from 'react-outside-click-handler';
import _map from 'lodash/map';
import { EMPTY_ARRAY, EMPTY_STRING } from '@tekion/tekion-base/app.constants';
import Icon from '../../../atoms/FontIcon';
import s from './styleButton.module.scss';
import PropertyControlledComponent from '../../PropertyControlledComponent';
var StyleButtonWithDropdown = /*#__PURE__*/function (_React$Component) {
  _inherits(StyleButtonWithDropdown, _React$Component);
  var _super = _createSuper(StyleButtonWithDropdown);
  function StyleButtonWithDropdown() {
    var _this;
    _classCallCheck(this, StyleButtonWithDropdown);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      showDropDown: false
    });
    _defineProperty(_assertThisInitialized(_this), "renderMenu", function () {
      var _this$props = _this.props,
        items = _this$props.items,
        active = _this$props.active;
      return /*#__PURE__*/React.createElement("div", {
        className: cx(s.styleMenu)
      }, _map(items, function (item) {
        return (
          /*#__PURE__*/
          // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
          React.createElement("span", {
            role: "menu",
            tabIndex: "-1",
            className: cx(s.styleMenuItem, _defineProperty({}, s.active, active)),
            key: item.value,
            onMouseOver: _this.onMouseOverHandler(item.value),
            onMouseDown: _this.onMouseDownHandler(item.value)
          }, item.render())
        );
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "onMouseOverHandler", function (value) {
      return function () {
        var onClick = _this.props.onClick;
        onClick(value);
      };
    });
    _defineProperty(_assertThisInitialized(_this), "onMouseDownHandler", function (value) {
      return function () {
        var onClick = _this.props.onClick;
        onClick(value);
        _this.hideMenu();
      };
    });
    _defineProperty(_assertThisInitialized(_this), "toggleMenu", function () {
      var showDropDown = _this.state.showDropDown;
      _this.setState({
        showDropDown: !showDropDown
      });
    });
    _defineProperty(_assertThisInitialized(_this), "openMenu", function () {
      _this.setState({
        showDropDown: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "hideMenu", function () {
      _this.setState({
        showDropDown: false
      });
    });
    return _this;
  }
  _createClass(StyleButtonWithDropdown, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        buttonClassName = _this$props2.buttonClassName,
        icon = _this$props2.icon,
        active = _this$props2.active;
      var showDropDown = this.state.showDropDown;
      return /*#__PURE__*/React.createElement("span", {
        className: cx(s.btn, buttonClassName, _defineProperty({}, s.active, active)),
        role: "button",
        onMouseEnter: this.openMenu,
        tabIndex: "-1"
      }, /*#__PURE__*/React.createElement(OutsideClickHandler, {
        onOutsideClick: function onOutsideClick() {
          return _this2.hideMenu();
        }
      }, /*#__PURE__*/React.createElement(PropertyControlledComponent, {
        controllerProperty: showDropDown
      }, this.renderMenu())), /*#__PURE__*/React.createElement(Icon, null, icon));
    }
  }]);
  return StyleButtonWithDropdown;
}(React.Component);
StyleButtonWithDropdown.propTypes = {
  onClick: PropTypes.func.isRequired,
  icon: PropTypes.string.isRequired,
  items: PropTypes.array,
  active: PropTypes.bool,
  buttonClassName: PropTypes.string
};
StyleButtonWithDropdown.defaultProps = {
  items: EMPTY_ARRAY,
  active: false,
  buttonClassName: EMPTY_STRING
};
export default StyleButtonWithDropdown;